import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Proof() {
  return <section className="bg-gold-500 py-20 px-6" data-id="element-171">
      <div className="max-w-4xl mx-auto text-center" data-id="element-172">
        <FadeIn data-id="element-173">
          <div className="bg-white rounded-3xl p-8 md:p-16 shadow-xl" data-id="element-174">
            <span className="block font-serif text-6xl md:text-8xl font-bold text-navy-900 mb-6" data-id="element-175">
              40%
            </span>
            <p className="text-xl md:text-2xl text-charcoal-800 leading-relaxed font-medium" data-id="element-176">
              En los primeros 7 días de entrenamiento, la mayoría de las
              usuarias reportan una reducción del 40% en los "momentos de
              confusión" diarios y una mayor facilidad para encontrar las
              palabras correctas durante una conversación fluida.
            </p>
            <p className="mt-8 text-sm text-charcoal-500 uppercase tracking-wider font-semibold" data-id="element-177">
              Basado en reportes de usuarias del método
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}